import request from '@/utils/request'

export function searchPerson(queryString, type) {
  return request({
    url: 'person/search/' + queryString + '/' + type,
    method: 'get'
  })
}

export function getAll(page_size, currentPage, document) {
  return request({
    url: 'person/getAll/' + page_size +'/' +document + '?page=' + currentPage,
    method: 'get'
  })
}

export function edit(id) {
  return request({
    url: 'person/getById/' + id,
    method: 'get'
  })
}

export function store(data) {
    return request({
      url: 'person/save',
      method: 'post',
      data
    })
  }
  
  export function update(data) {
    return request({
      url: 'person/update',
      method: 'put',
      data
    })
  }

  export function deletePerson(id) {
    return request({
      url: 'person/destroy',
      method: 'delete',
      data: id
    })
  }

  export function downloadDocument(id) {
    return request({
      url: 'person/downloadDocument/' + id,
      method: 'get',
      responseType: 'arraybuffer'
    })
  }
  export function deleteDocument(id) {
    return request({
      url: 'person/deleteDocument/' + id,
      method: 'get'
    })
  }